import React from "react"; 
import { NavigateFunction } from "react-router-dom";
import BlueDots from "../../../../../../images/common/blue-dots.svg";
import OrdersIcon from "../../../../../../images/common/cart-blue.svg";
import CartIcon from "../../../../../../images/common/cart-blue.svg";  
import { ActiveInactiveButton, ITableHeaders,  TableWithHeaderButtons, withRouter } from "@mindmemobile/mm-shared-global";
import { CountryWithStateModel, PurchaseLinkOrdersGridModel, SystemColorsModel } from "../../../shared/models";
import { PlaceholderSmallerGrid, TableGrid } from "../../../shared/components";
import { GridNames } from "../../../shared/enums";


type IProps = {
  navigate: NavigateFunction;
  orders: PurchaseLinkOrdersGridModel[];
  countriesWithState: CountryWithStateModel[];  
};
const PurchaseLinkOrdersGrid: React.FC<IProps> = ({ orders ,countriesWithState}) => {
  const headers = () => {
      const columns: ITableHeaders<PurchaseLinkOrdersGridModel>[] = [
          {
              dataKey: 'status',
              title: 'Status',
              onCellRender: (data: PurchaseLinkOrdersGridModel) => {
                  let colors = SystemColorsModel.lightGreyColors();

                  switch (data.status) {
                      case 'Draft':
                          colors = SystemColorsModel.lightGreyColors();
                          break;
                      case 'Sold':
                          colors = SystemColorsModel.ligthGreenColors();
                          break;
                  }
                  return (
                      <ActiveInactiveButton color={colors.color} bgColor={colors.bgColor}>
                          {data.status}
                      </ActiveInactiveButton>
                  );
              },
          },
          {
              dataKey: 'created',
              title: 'Created',
              onCellRender: (data: PurchaseLinkOrdersGridModel) => {
                  return data.created;
              },
          },

          {
              dataKey: 'description',
              title: 'Description',
              onCellRender: (data: PurchaseLinkOrdersGridModel) => {
                  return data.description;
              },
          },
          {
              dataKey: 'items',
              title: 'Items',
              onCellRender: (data: PurchaseLinkOrdersGridModel) => {
                  return data.items;
              },
          },
          {
              dataKey: 'amount',
              title: 'Amount',
              onCellRender: (data: PurchaseLinkOrdersGridModel) => {
                  return '$' + data.amount;
              },
          },
          {
              dataKey: 'recurring',
              title: 'Recurring',
              onCellRender: (data: PurchaseLinkOrdersGridModel) => {
                  return data.recurring;
              },
          },
          {
              dataKey: 'recurring',
              title: 'Actions',
              className: 'table-col-10 text-center',
              cellClassName: 'table-col-10 text-center',
              onCellRender: () => {
                  return (
                      <div>
                          <img src={BlueDots} className="blue-dots" />
                      </div>
                  );
              },
          },
      ];
      return columns;
  };

  if (orders.length == 0) return <PlaceholderSmallerGrid title="No Orders" icon={CartIcon} buttonCaption="New" />;

  return (
      <TableGrid
          wrapperClassName="table-with-header-btns"
          tableHeader={
              <TableWithHeaderButtons
                  isShowHeaderButton={true}
                  totalItems={orders.length}
                  icon={OrdersIcon}
                  title="Orders"
              />
          }
          cellSpacing={20}
          headers={headers()}
          data={orders}
          totalItemCount={orders.length}
          name={GridNames.Order}
          countriesWithState={countriesWithState}
      />
  );
};

export default withRouter(PurchaseLinkOrdersGrid);
